"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLinearStreamProperty = exports.linearStreamPropertyDefinition = void 0;
exports.linearStreamPropertyDefinition = {
    view: { label: 'Video essence' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'providers',
            argument: ['DMS Linear Stream'],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'linear-stream',
};
const isLinearStreamProperty = (prop) => {
    return prop.name === exports.linearStreamPropertyDefinition.name;
};
exports.isLinearStreamProperty = isLinearStreamProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluZWFyLXN0cmVhbS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2xpbmVhci1zdHJlYW0ucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFO0lBQ2hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUMsbUJBQW1CLENBQUM7U0FDaEM7S0FDRjtJQUNELElBQUksRUFBRSxTQUFTO0lBQ2YsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsZUFBZTtDQUNVLENBQUE7QUFJMUIsTUFBTSxzQkFBc0IsR0FBRyxDQUFDLElBQWtCLEVBQWdDLEVBQUU7SUFDekYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHNDQUE4QixDQUFDLElBQUksQ0FBQTtBQUMxRCxDQUFDLENBQUE7QUFGWSxRQUFBLHNCQUFzQiwwQkFFbEMifQ==